import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ERROR_EVENT_ENUM } from '../constants';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root',
})
export class CoralogixErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}
  private loggingService: LoggingService;

  handleError = async (errorPayload: any) => {
    try {
      // avoid circular DI
      if (!this.loggingService) {
        this.loggingService = this.injector.get(LoggingService);
      }
      this.loggingService.logEvent({
        type: 'error',
        eventName: ERROR_EVENT_ENUM.COMMON_ERROR,
        eventPayload: {
          error: errorPayload,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };
}
